import AbstractComponent from "./abstract-component";
import Logo from './logo';
import {utils} from "@/tools/pdf";

const {zero} = utils;

/**
 * @param {Object} data
 *  title: Object | String Object definition or string title itself.
 *  description: ''
 *  cta: ''
 *  ctaHref: ''
 *  image: null
 *
 *  @param {Object} options
 *    hero: false Renders it taller
 *    marginTop: 0
 *    marginBottom: 0
 */
class Header extends AbstractComponent {
  render() {
    const {
      data: {title, description, image, cta, ctaHref},
      options: {hero, marginTop, marginBottom, paddingTop, paddingBottom}
    } = this;

    if (hero || image) {
      return {
        table: {
          widths: ['100%'],
          body: [
            [{
              columns: [
                [
                  Logo(undefined, {}),
                  {
                    text: title,
                    style: 'header',
                    width: hero && 400,
                    margin: [0, 10, 0, 0]
                  },
                  description && {
                    text: description,
                    style: 'subHeader',
                    width: 300,
                    margin: [162, 15, 162, 0]
                  },
                  cta && {
                    text: cta,
                    link: ctaHref,
                    style: 'headerLink',
                    margin: hero && [0, 10, -60, 0]
                  }
                ].filter(Boolean),
              ].filter(Boolean),
              margin: [
                0,
                (hero ? 20 : 0) + paddingTop,
                0,
                paddingBottom
              ]
            }]
          ]
        },
        margin: [0, marginTop, 0, marginBottom],
        layout: this.getTableLayout(),
      }
    } else {
      return this.renderTextTitle();
    }
  }

  getDefaultOptions() {
    return {
      hero: false,
      marginTop: 0,
      marginBottom: 60,
      paddingTop: 0,
      paddingBottom: 0,
    }
  }

  renderTextTitle() {
    const {data: {title}, options: {marginTop, marginBottom}} = this;

    return {
      columns: [
        [
          {
            image: 'logo',
            width: 196,
            alignment: 'center',
          },
          title && {text: title, style: 'header', margin: [0, 4]}
        ].filter(Boolean)
      ],
      margin: [0, marginTop, 0, marginBottom]
    }
  }

  getTableLayout() {
    const {options: {bottomBorderWidth}} = this;
    return {
      hLineWidth: (i, node) => i === node.table.body.length ? bottomBorderWidth : 0,
      vLineWidth: zero,
      paddingBottom: zero,
      paddingLeft: zero,
      paddingRight: zero,
      paddingTop: zero,
    }
  }
}

export default Header.asFunction();
